import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/alerts")({
  staticData: {
    title: "edge.navigation.alerts",
  },
});
